/** Design px -> rem, against the app's 12px root. */
export const rem = (value: number): string => `${value / 12}rem`;
